<template>
  <div class="profile-steps">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 cus-step-wrap pl-0"
      >
        <div class="flex_content py-4">
          <ProgressBar :scale="progress" v-if="$route.query['data-id']" />
        </div>
        <div class="step-progress__wrapper">
          <div class="step-progress__bar md-layout">
            <div class="md-medium-size-33 md-layout-item md-xsmall-size-100 custom-step-pro p-0">
              <div
                id="salesDiv"
                class="step-progress__step step-progress__step--valid"
                @click="selectedTab($event)"
              >
                <span class="step">1</span>
                <div class="step-progress__step-icon fa fa-check"></div>
                <div class="step-progress__step-label">
                  <div class="arrow-up"></div>Sales
                </div>
                <div class="step-progress__step-sub-label">
                  <div class="progress-step-actions">
                    <div class="action-text" @click="openSelector()">
                      {{
                        $store.getters.multCurrentSalesClass
                          ? getData($store.getters.multCurrentSalesClass)
                          : 'Select Sales Group'
                      }}
                      <md-icon v-if="$store.getters.industry != null" class="action-icon">replay</md-icon>
                    </div>
                  </div>
                </div>
                <div class="dropdownMenu">
                  <nav-tabs-card no-label md-elevation="0">
                    <template slot="content">
                      <md-tabs md-alignment="left" id="finantialProfileTabs">
                        <sales-tab :key="salesKey" :dataAccess="this.dataAccess" />
                      </md-tabs>
                    </template>
                  </nav-tabs-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { NavTabsCard } from '@/components';
import SalesTab from './SalesTab';

export default {
  name: 'sales-select',
  components: {
    NavTabsCard,
    SalesTab,
  },
  data() {
    return {
      classicModal: false,
      progress: 70,
      salesKey: 0,
    };
  },
  props: ['dataAccess'],
  methods: {
    forceRerender() {
      this.salesKey += 1;
    },
    getData: function (name) {
      if (name) {
        return name.split('[')[1].split(']')[1];
      }
    },
    getTitle: function (name) {
      if (name) {
        return name.split('[')[0];
      }
    },
    openSelector: function(name) {
      let selectorDiv = document.getElementById('salesDiv');
      if(selectorDiv.classList.contains('open'))
          selectorDiv.classList.remove('open')       
      else  
          selectorDiv.classList.add('open')
    },
    toArray: function (arrLike) {
      return [].slice.call(arrLike);
    },
    validateClickOutside: function (activeClass) {
      let openClass = document.getElementsByClassName('open');
      if (openClass)
        [].forEach.call(openClass, function (el) {

          el.classList.remove('open');
        })
    },
    selectedTab: function (e) {
      let activeClass = e.target.parentElement;

      if (activeClass.classList.contains('open')) {
        activeClass.classList.remove('open');
        this.validateClickOutside(activeClass);
        e.stopPropagation();
      } else {
        this.validateClickOutside(activeClass);
        e.stopPropagation();
        let elems = document.querySelector('.progress-step-actions');

        [].forEach.call(elems, function (el) {
          el.classList.remove('open');
        });
        activeClass.classList.add('open');
      }
      let elems = this.toArray(document.querySelectorAll('.md-tab-nav-button'));
      elems.forEach(function (el) {
        el.classList.remove('md-active');
      });
      let currentTab = parseInt(e.currentTarget.firstElementChild.innerText);
      document
        .querySelectorAll('.md-tab-nav-button')
      [currentTab - 1].classList.add('md-active');
    },
  },
  computed: {
    multCount() {
      return this.$store.getters.multCount;
    }
  },
  watch: {
    multCount(newValue, oldValue) {
      if (newValue == null)
        this.forceRerender()
    }
  },

};
</script>
<style lang="scss" scoped>
.info-btn-custom {
  background-color: white !important;
  &:hover {
    background-color: white !important;
    box-shadow: none;
  }
}
.step-progress__step:hover {
  cursor: pointer;
}
.action-text {
  opacity: 1 !important;
  transform: unset !important;
  font-size: 14px !important;
}
.custom-step-pro::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  height: 2px;
  width: 96%;
  background-color: grey;
  z-index: -1;
}
.custom-step-pro:last-child::before {
  content: none;
}
@media screen and (max-width: 1280px) and (min-width: 600px) {
  .custom-step-pro:nth-child(4),
  .custom-step-pro:nth-child(5) {
    margin-top: 130px;
  }
  .custom-step-pro:nth-child(3)::before {
    content: none;
  }
  .cus-step-wrap {
    padding-top: 20px;
  }
  .step-progress__step:after {
    width: 30px !important;
    height: 30px !important;
  }
  .step-progress__step span {
    font-size: 18px;
  }
  .step-progress__step-icon {
    font-size: 12px !important;
  }
}
@media only screen and (max-width: 600px) {
  .custom-step-pro::before {
    left: -6%;
    top: 369%;
    width: 27%;
    transform: rotate(90deg);
  }
  .custom-step-pro {
    margin-bottom: 80px;
  }
  .step-progress__step-label .arrow-up {
    display: none;
  }
  .step-progress__step:after {
    left: 8%;
    top: 150%;
  }
  .step-progress__step-icon {
    left: 8%;
    top: 150%;
  }
  .step-progress__step-label {
    top: 0;
    left: 63%;
  }
  .custom-step-pro:nth-child(4),
  .custom-step-pro:nth-child(5) {
    margin-top: unset;
  }
  .step-progress__step:after {
    width: 30px !important;
    height: 30px !important;
  }
  .step-progress__step span {
    font-size: 18px;
  }
  .step-progress__step-icon {
    font-size: 12px !important;
  }
  .cus-step-wrap {
    padding-top: 20px;
  }
}
</style>
